import React from "react";
import { useField } from "formik";

interface ChedaGamingInputProps {
  name: string;
  label?: string;
  labelSubtext?: string;
  type?: string;
  as?: "input" | "textarea";
  inputSubtext?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  normalize?: (value: string) => string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  value?: any;
  error?: string | undefined;
  rows?: number;
  touched?: boolean;
  keyboardType?:
    | "text"
    | "email"
    | "search"
    | "tel"
    | "url"
    | "none"
    | "numeric"
    | "decimal";
}

const ChedaGamingInput: React.FC<ChedaGamingInputProps> = ({
  name,
  label,
  labelSubtext,
  type = "text",
  as = "input",
  inputSubtext,
  placeholder,
  required = false,
  disabled = false,
  icon,
  className,
  style,
  normalize,
  onChange,
  onBlur,
  value,
  error,
  touched,
  rows = 4,
  keyboardType,
}) => {
  const [field, meta, helpers] = useField(name);

  const handleLocalChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const val = e.target.value;
    const newVal = normalize ? normalize(val) : val;
    helpers.setValue(newVal);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    onChange?.(e as any);
    handleLocalChange(e);
  };

  const handleBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    onBlur?.(e as any);
    field.onBlur(e as any);
  };

  const inputValue = value !== undefined ? value : field.value;
  const showError = (touched ?? meta.touched) && (error ?? meta.error);

  return (
    <div className={`form-group ${className || ""}`} style={style}>
      {label && (
        <label className="form-label">
          {label}{" "}
          {labelSubtext && (
            <span
              style={{
                fontWeight: 400,
                fontSize: "0.9em",
                color: "#888",
              }}
            >
              {labelSubtext}
            </span>
          )}
        </label>
      )}
      <div className="input-container">
        {icon}
        {as === "textarea" ? (
          <textarea
            {...field}
            placeholder={placeholder}
            onChange={handleChange}
            onBlur={handleBlur}
            value={inputValue}
            required={required}
            disabled={disabled}
            rows={rows}
            className="form-input"
          />
        ) : (
          <input
            {...field}
            type={type}
            placeholder={placeholder}
            onChange={handleChange}
            onBlur={handleBlur}
            value={inputValue}
            required={required}
            disabled={disabled}
            className="form-input"
            inputMode={keyboardType}
          />
        )}
      </div>
      {inputSubtext && <small style={{ color: "#888" }}>{inputSubtext}</small>}
      {showError && (
        <div className="input-error">{(error ?? meta.error) as string}</div>
      )}
    </div>
  );
};

export default ChedaGamingInput;
